<template>
  <div class="contactus-mian">
    <div class="cantactus-box">
      <div class="titleBox" style="margin-bottom: 20px">
        <div class="title">联系我们</div>
      </div>
      <div class="map-box">
        <!-- <div class="map-left">
          <img @click="TiaoZhuan" src="../assets/img/DiTu2.jpg" alt="" />
        </div> -->
        <div class="right-us">
          <div class="left-box">
            <div class="us-list">
              <div>
                <div class="title-us">办公地址：</div>
                <p>
                  江西省南昌小蓝经济开发区汇仁大道999号
                </p>
              </div>
            </div>
            <div class="us-list">
              <div>
                <div class="title-us">学校电话：</div>
                <p>培训业务电话：0791-87302656</p>
                <p>网站服务电话：400-999-9355</p>
              </div>
            </div>
          </div>
          <div class="right-box">
            <div class="us-list">
              <div>
                <div class="title-us">邮编地址：</div>
                <p>邮政编码：330200</p>
                <p>网站网址：https://jxag.etledu.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // url:'https://ditu.so.com/?k=%E5%8D%97%E6%98%8C%E5%B8%82%E7%BA%A2%E8%B0%B7%E6%BB%A9%E5%8C%BA%E5%BA%90%E5%B1%B1%E5%8D%97%E5%A4%A7%E9%81%931659%E5%8F%B7&src=onebox'
      url: "https://map.360.cn/?k=%E5%8D%97%E6%98%8C%E5%B8%82%E7%BA%A2%E8%B0%B7%E6%BB%A9%E5%8C%BA%E5%BA%90%E5%B1%B1%E5%8D%97%E5%A4%A7%E9%81%931659%E5%8F%B7&src=onebox",
    };
  },
  methods: {
    TiaoZhuan() {
      window.open(this.url, "_blank");
    },
  },
};
</script>

<style lang="less">
@import url("../assets/css/main.less");
</style>



// WEBPACK FOOTER //
// src/components/contactus.vue